import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { newCampaignActions } from '../../../../store';
import Hint from '../../../Tools/Hint';

const Location = ({ location, selectedCurrency, dispatch }) => {
    const { t } = useTranslation();
    const nodes = location.nodes;
    const countries = location.countries;
    const selectedCountries = location.selectedCountries;
    const regions = location.regions;
    const selectedRegions = location.selectedRegions;
    const cities = location.cities;
    const selectedCities = location.selectedCities;
    const neighborhood = location.neighborhood;
    const selectedNeighborhoods = location.selectedNeighborhoods;
    const countriesName = [];

    const change = (attribute, value) => {
        const isCountry = attribute === 'selectedCountries';
        if (isCountry && value.length === 0) {
            return;
        }
        const newLocation = Object.assign({}, location);
        newLocation[attribute] = value;
        dispatch(newCampaignActions.setLocation(newLocation));
    };

    return (
        <div className="module rounded m-1 mb-4">
            <div className="header flex justify-between content-center">
                <div className="title text-xl font-extralight">
                    {t(
                        'sections.campaigns.new-campaign.wizard-basics.location.title'
                    )}
                </div>
                <div className="brief font-light text-xs text-gray-400 mt-1.5 text-right">
                    {t(
                        'sections.campaigns.new-campaign.wizard-basics.location.info'
                    )}
                </div>
            </div>
            <div className="body rounded-sm p-1">
                <label className="block md:w-3/6 -mb-2">
                    <span className="block text-sm font-medium text-gray-700">
                        {t(
                            'sections.campaigns.new-campaign.wizard-basics.location.countries-label'
                        )}
                    </span>
                    <Select
                        className=""
                        options={countries}
                        defaultValue={selectedCountries}
                        onChange={(countriesOptions) =>
                            change('selectedCountries', countriesOptions)
                        }
                        isMulti={true}
                        placeholder={t(
                            'sections.campaigns.new-campaign.wizard-basics.location.countries-placeholder'
                        )}
                    />
                    <Hint
                        className="relative -top-8 ml-2 left-full"
                        title={t(
                            'sections.campaigns.new-campaign.wizard-briefBar.location.country'
                        )}
                        text={
                            selectedCountries.length !== 0
                                ? t(
                                      'sections.campaigns.new-campaign.wizard-basics.location.currency-label'
                                  ) + `${selectedCurrency.short_name}`
                                : ''
                        }
                    />
                </label>
                {selectedCountries.length == 0 ? null : (
                    <label className="block md:w-3/6 mb-4">
                        <span className="block text-sm font-medium text-gray-700">
                            {t(
                                'sections.campaigns.new-campaign.wizard-basics.location.regions-label'
                            )}
                        </span>
                        <Select
                            options={regions}
                            value={selectedRegions}
                            onChange={(selectedRegions) =>
                                change('selectedRegions', selectedRegions)
                            }
                            isMulti={true}
                            isSearchable={true}
                            placeholder={t(
                                'sections.campaigns.new-campaign.wizard-basics.location.regions-placeholder'
                            )}
                        />
                    </label>
                )}
                {selectedRegions.length == 0 ? null : (
                    <label className="block md:w-3/6 mb-4">
                        <span className="block text-sm font-medium text-gray-700">
                            {t(
                                'sections.campaigns.new-campaign.wizard-basics.location.cities-label'
                            )}
                        </span>
                        <Select
                            options={cities}
                            value={selectedCities}
                            onChange={(selectedCities) =>
                                change('selectedCities', selectedCities)
                            }
                            isMulti={true}
                            isSearchable={true}
                            placeholder={t(
                                'sections.campaigns.new-campaign.wizard-basics.location.cities-placeholder'
                            )}
                        />
                    </label>
                )}
                {selectedCities.length == 0 ? null : (
                    <label className="block md:w-3/6 mb-4">
                        <span className="block text-sm font-medium text-gray-700">
                            {t(
                                'sections.campaigns.new-campaign.wizard-basics.location.neighbourhood-label'
                            )}
                        </span>
                        <Select
                            options={neighborhood}
                            value={selectedNeighborhoods}
                            onChange={(selectedNeighborhoods) =>
                                change(
                                    'selectedNeighborhoods',
                                    selectedNeighborhoods
                                )
                            }
                            isMulti={true}
                            isSearchable={true}
                            placeholder={t(
                                'sections.campaigns.new-campaign.wizard-basics.location.neighbourhood-placeholder'
                            )}
                        />
                    </label>
                )}
            </div>
        </div>
    );
};

export default Location;
